import _slicedToArray from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["embedParameters", "lazyLoad", "name", "videoId"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { youTubeEmbedParams, youTubeAspectRatio } from "./types";
import { EmbedContainer } from "./youtube-player.styles";
import { jsx as _jsx } from "react/jsx-runtime";
var YOUTUBE_BASE_URL = 'https://www.youtube.com/embed';
var getSrcDoc = function getSrcDoc(url, _ref) {
  var videoId = _ref.videoId,
    _ref$name = _ref.name,
    _name = _ref$name === void 0 ? '' : _ref$name;
  return "<style>  *{padding:0;margin:0;overflow:hidden}  html,body{height:100%}  img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}  span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=".concat(url, ">  <img src=https://img.youtube.com/vi/").concat(videoId, "/maxresdefault.jpg alt='").concat(_name, "'>  <span>&#x25BA;</span></a>");
};

/**
 * Accepts embed parameters as specified here:
 * Documentation: https://developers.google.com/youtube/player_parameters#Parameters
 */
var YouTubePlayer = function YouTubePlayer(props) {
  var embedParameters = props.embedParameters,
    lazyLoad = props.lazyLoad,
    name = props.name,
    videoId = props.videoId,
    rest = _objectWithoutProperties(props, _excluded);
  var queryString = Object.entries(embedParameters).reduce(function (prev, _ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    return !String(value) ? prev : "".concat(prev).concat(key, "=").concat(value, "&");
  }, '');
  var url = "".concat(YOUTUBE_BASE_URL, "/").concat(videoId, "?").concat(queryString);
  var srcDoc = lazyLoad ? getSrcDoc(url, props) : undefined;
  return /*#__PURE__*/_jsx(EmbedContainer, _objectSpread(_objectSpread({}, rest), {}, {
    children: /*#__PURE__*/_jsx("iframe", {
      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
      allowFullScreen: true,
      frameBorder: 0,
      loading: "lazy",
      src: url,
      srcDoc: srcDoc,
      title: name
    })
  }));
};
YouTubePlayer.displayName = 'YouTubePlayer';
YouTubePlayer.propTypes = {
  aspectRatio: youTubeAspectRatio.isRequired,
  embedParameters: youTubeEmbedParams.isRequired,
  lazyLoad: PropTypes.bool,
  name: PropTypes.string,
  videoId: PropTypes.string.isRequired
};
YouTubePlayer.defaultProps = {
  lazyLoad: false,
  name: 'Typeform'
};
export default /*#__PURE__*/memo(YouTubePlayer);